import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useTranslations } from "next-intl";
import { AlertDialogWrapper } from "@components/common/containers/alert-dialog-wrapper";
import { Badge } from "@components/ui/badge";
import { proposalsTools } from "@features/proposals/proposals-tools";
import { ActivityMemberEntity, ActivityMemberInputView } from "@features/proposals/types/member";
import { MemberNotifeeStatus } from "@features/proposals/ui/member/member-notifee-status";
import { MemberPublicationConsentStatus } from "@features/proposals/ui/member/member-publication-consent-status";
interface MemberConsentsDialogProps {
  member: ActivityMemberEntity;
  patchMember: (member: ActivityMemberEntity, body: Partial<ActivityMemberInputView>) => Promise<undefined | ActivityMemberEntity>;
}

/**
 * Dialog component for displaying member consents and notification preferences.
 * Triggered by a badge in the member view header.
 */
export const MemberConsentsDialog = t0 => {
  const $ = _c(23);
  const {
    member,
    patchMember
  } = t0;
  const t = useTranslations("features.proposals.ui.memberConsentsDialog");
  const tStatus = useTranslations("features.proposals.ui.memberPublicationConsentStatus");
  let t1;
  if ($[0] !== member) {
    t1 = proposalsTools.activityMemberTools.isMemberPublicationConsentAccepted(member);
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isAccepted = t1;
  if (isAccepted === null) {
    return null;
  }
  const t2 = isAccepted ? "default" : "destructive";
  let t3;
  if ($[2] !== t) {
    t3 = t("trigger");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isAccepted || $[5] !== tStatus) {
    t4 = isAccepted === true ? tStatus("status.accepted") : isAccepted === false ? tStatus("status.revoked") : tStatus("status.notAccepted");
    $[4] = isAccepted;
    $[5] = tStatus;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Badge variant={t2} className="cursor-pointer">{t3}:{" "}{t4}</Badge>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("title");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("description");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== member || $[16] !== patchMember) {
    t8 = <div className="flex flex-col gap-4"><MemberPublicationConsentStatus member={member} patchMember={patchMember} /><MemberNotifeeStatus member={member} patchMember={patchMember} /></div>;
    $[15] = member;
    $[16] = patchMember;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <AlertDialogWrapper trigger={t5} title={t6} description={t7}>{t8}</AlertDialogWrapper>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};